<div class="navigation-panel-container" [@slideIn]>
  <div class="navigation-panel-header">
    @if (title) {
      <h2 class="navigation-panel-title">{{ title }}</h2>
    }
    <div class="nav-home">
      <img (click)="home()" src="assets/images/CRC_logo.svg" alt="ResourceCenter logo" />
    </div>
    <button class="navigation-panel-close-button" (click)="close()" aria-label="Close panel">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
        <path d="M0.5 0.5L8.5 8.5" stroke="var(--Icon-action-hover, #0074EB)" stroke-width="1px" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.5 0.5L0.5 8.5" stroke="var(--Icon-action-hover, #0074EB)" stroke-width="1px" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  <div class="navigation-panel-content">
    <div class="menu-layout">
      <div class="menu-group">
        @for (item of visibleMenuItems; track $index){
          @if (!item.bottom && isVisible(item)) {
            @if (item.group == 1 && isCustomer || item.group == 2 && isPartner || item.group === undefined) {
              <app-menu-item [navItem]="item" (menuClickEvent)="toggle(item)"></app-menu-item>
            }
          }
        }
      </div>

      <div class="menu-group">
        @for (item of visibleMenuItems; track $index){
          @if (item.bottom) {
            <app-menu-item [navItem]="item" (menuClickEvent)="toggle(item)"></app-menu-item>
          }
        }
      </div>
    </div>
  </div>
</div>
